import '@/sui/less/all.less'
import '@babel/polyfill'
import 'events-polyfill'
import 'chartjs-plugin-datalabels'

import initComponents from '@/sui/components/init'
import initApi from '@/sui/api/init'
import app from '@/app'
import router from '@/router/router'
import store from '@/store/store'

import check from '@/check'

import * as uiv from 'uiv'
import vueAsyncComputed from 'vue-async-computed'
import vueSmoothScroll from 'vue2-smooth-scroll'
import vueShortKey from 'vue-shortkey'
import vueSticky from 'vue-sticky-directive'
import moment from 'moment'
import locale from 'uiv/src/locale/lang/fr-FR'
import Vue from 'vue'

const debug = process.env.VUE_APP_SPIADI_DEBUG === '1'
if (debug) {
  check()
}

Vue.config.productionTip = false
Vue.use(uiv, { locale })
Vue.use(vueAsyncComputed)
Vue.use(vueSmoothScroll)
Vue.use(vueShortKey)
Vue.use(vueSticky)
moment.locale('fr')

initComponents()

store.dispatch('cloud/getConfig')

new Vue({
  created: function () {
    initApi(store, 'user', router)
  },
  router,
  store,
  render: h => h(app)
}).$mount('#app')
